var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 5H0.833333C0.375 5 0 5.29661 0 5.65913V11.3409C0 11.7034 0.375 12 0.833333 12H2.16667C2.625 12 3 11.7034 3 11.3409V5.65913C3 5.29002 2.625 5 2.16667 5Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 3H5.33333C4.875 3 4.5 3.29327 4.5 3.6517V11.3483C4.5 11.7067 4.875 12 5.33333 12H6.66667C7.125 12 7.5 11.7067 7.5 11.3483V3.6517C7.5 3.29327 7.125 3 6.66667 3Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 1H9.83333C9.375 1 9 1.29118 9 1.64706V11.3529C9 11.7088 9.375 12 9.83333 12H11.1667C11.625 12 12 11.7088 12 11.3529V1.64706C12 1.29118 11.625 1 11.1667 1Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBars);
export default __webpack_public_path__ + "static/media/chart-bars.b5fc97178b2811e0d3908e07b5e84b79.svg";
export { ForwardRef as ReactComponent };